import { Action } from '@ngrx/store';
import { ErrorResponse } from '~shared/models';

import { Seller } from '../../models';

export enum SellerActionTypes {
  LOAD_SELLER = '[Seller] Seller read',
  LOAD_SELLER_SUCCESS = '[Seller] Seller load success',
  LOAD_SELLER_FAILURE = '[Seller] Seller load failure',
}

export class LoadSeller implements Action {
  readonly type = SellerActionTypes.LOAD_SELLER;

  constructor(public payload: { id: string }) {}
}

export class LoadSellerSuccess implements Action {
  readonly type = SellerActionTypes.LOAD_SELLER_SUCCESS;

  constructor(public payload: { seller: Seller }) {}
}

export class LoadSellerFailure implements Action {
  readonly type = SellerActionTypes.LOAD_SELLER_FAILURE;

  constructor(public payload: { error: ErrorResponse }) {}
}

export type SellerActionsUnion = LoadSeller | LoadSellerSuccess | LoadSellerFailure;
